module.exports = __webpack_public_path__ + "static/media/cases_3d_05d.ba1cabac.jpg";